export const negotiationCommunicationResourceType = 'negotiation_communication';
